import backend from '@common/backend';

const BASE = '/cgStudents';

export interface IGetCgStudentsQuery {
	search?: string;
	page?: number;
	limit?: number;
	product_id?: number;
	category_id?: number;
	c_g_counselor_id?: number;
	has_workshop_purchase?: 0 | 1;
	has_completed_all_workshop_assessments?: 0 | 1;
}

export interface InviteCgStudent {
	first_name: string;
	last_name: string;
	email: string;
	c_g_class_id?: number;
}

export const getCgStudents = async (query: IGetCgStudentsQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const getCgStudentsWithCounselor = (query: IGetCgStudentsQuery = {}) =>
	backend.get(`${BASE}/withCounselor`, { params: query });

export const getCgStudentsWithoutCounselor = (query: IGetCgStudentsQuery = {}) =>
	backend.get(`${BASE}/withoutCounselor`, { params: query });

export const getCgStudentsWithoutCounselorCount = async () =>
	backend.get(`${BASE}/withoutCounselor/count`);

export const getUnacceptedCgStudents = async (query: IGetCgStudentsQuery) =>
	backend.get(`${BASE}/unaccepted`, {
		params: query,
	});

export const getCgStudent = async (id: number) => backend.get(`${BASE}/${id}`);

export const createCgStudent = async (data: any) => backend.post(`${BASE}`, data);

export const acceptCgStudent = async (id: number) => backend.post(`${BASE}/${id}/accept`, {});

export const declineCgStudent = async (id: number) => backend.post(`${BASE}/${id}/decline`, {});

export const loginByCgStudent = async (id: any) => backend.post(`${BASE}/${id}/impersonate`, {});

export const removeCgStudent = async (id: number) => backend.delete(`${BASE}/${id}`);

export const removeCgStudentFromCoordinator = async (id: number) =>
	backend.delete(`${BASE}/${id}/destroyWithUser`);

export const saveCgStudent = async (id: number, data: any) => backend.put(`${BASE}/${id}`, data);

export const createCgStudentInviteLink = async (data: InviteCgStudent) =>
	backend.post(`${BASE}/create`, data);

export const sendInviteCgStudentEmaiLink = async (data: InviteCgStudent) =>
	backend.post(`${BASE}/sendMail`, data);

export const toggleStudyWithTalentedGroup = async (id: number) => backend.patch(`${BASE}/${id}/toggleStudyWithTalantedGroup`, {});
